import React, { useMemo, useState, useEffect, useRef } from 'react';
import {
    Card, CardContent, Typography, Grid, Button, Box, TextField, Dialog, DialogContent, DialogTitle,DialogActions, IconButton, FormControl, Tooltip,
    InputLabel, Select, MenuItem,FormControlLabel,Radio,RadioGroup,
    OutlinedInput, InputAdornment, FormHelperText,
} from '@mui/material';
function VerifyIdentity({SnapShotErollStep1}) {
     const [verificationMethod, setVerificationMethod] = useState("phone"); // default
 return ( 
        <>
            <Grid container item lg={12} md={12} sm={12} xs={12} mt={1} mb={1}>
                <Grid item lg={7} md={7} sm={12} xs={12} display={"flex"} alignItems={"center"}>
                    <Typography fontWeight={"bold"} textTransform={"capitalize"} variant='body1'>Send verification link to</Typography>
                </Grid>
                <Grid item lg={5} md={5} sm={12} xs={12}>
                    <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={verificationMethod}
                            onChange={(e) => setVerificationMethod(e.target.value)}
                        >
                            <FormControlLabel value="phone" control={<Radio />} label="Text" />
                            <FormControlLabel value="email" control={<Radio />} label="Email" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container item lg={12} md={12} sm={12} xs={12}  display={"flex"} justifyContent={"end"} mt={1} mb={1}>
                <Button variant='contained' color='success' size='large' id="submit" onClick={() => SnapShotErollStep1(verificationMethod)} >SUBMIT</Button>
            </Grid>
        </>
        );
}
export default VerifyIdentity;